module.exports = __webpack_public_path__ + "img/press-3.36adda8e.jpg";